( (
  { hooks: { addFilter: addFilterBe } }
) => {
  // eslint-disable-line
  addFilterBe(
    'b3rg_meta_field_exclude_fields',
    'b3rg/meta_field',
    ( defaultValue ) => {
      /* uncomment for use this filter
      const updatedField = [
        'show_custom_date',
        'featured',
        'featured_image',
        'image_alt_text',
        'learn_more_type',
        'learn_more_link',
        'show_popup',
      ];
      return updatedField;
      */
      return defaultValue;
    }
  );

  // eslint-disable-line
  addFilterBe(
    'b3rg_meta_field_include_fields',
    'b3rg/meta_field',
    ( defaultMetaFieldsArray ) => {
      return [...defaultMetaFieldsArray, 'author_bio', 'post_excerpt'];
    }
  );

  addFilterBe( 'b3rg_meta_field_query', 'b3rg/meta_field', ( defaultValue ) => {
    /* uncomment for use this filter
    const query = {
      status: 'publish',
      include: 1900,
      exclude: 1800,
      ...
    };
    return query;
 */
    return defaultValue;
  } );
} )( wp ); // eslint-disable-line no-undef
